import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m10.25 8-4.045 4-.455-1.69L8.095 8 5.75 5.69 6.205 4l4.045 4Z"
      }
    )
  }
);
export {
  t as ChevronRightSmall
};
